import React from 'react'
import useLoadAllParticipantData from 'src/participant/useLoadAllParticipantData'
import VideoCallBookingHeader from './VideoCallBookingHeader'
import { CallNotesHandlerProvider, OpenCallNotes } from './VideoCallBookingHeader/CallNotesHandler'

type Props = {
  uid: string
  onOpenCallNotes?: OpenCallNotes
  showForProgram?: (programID: string | undefined) => boolean
}

const ParticipantCallHeader = ({ uid, onOpenCallNotes, showForProgram }: Props) => {
  const { patient } = useLoadAllParticipantData(uid)

  if (showForProgram && !showForProgram(patient?.enrollment?.programID)) {
    return null
  }

  return (
    <CallNotesHandlerProvider value={onOpenCallNotes ?? null}>
      <VideoCallBookingHeader uid={uid} participantWithFullInformation={patient} />
    </CallNotesHandlerProvider>
  )
}

export default ParticipantCallHeader
